import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NSelect = _resolveComponent("NSelect")!

  return (_ctx.readonly)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["camera-group-name", { 'camera-group-name__accent': _ctx.accent }])
      }, _toDisplayString(_ctx.name), 3))
    : (_openBlock(), _createBlock(_component_NSelect, _mergeProps({
        key: 1,
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _ctx.updateValue
      }, _ctx.props, { placeholder: _ctx.placeholder }), null, 16, ["modelValue", "onUpdate:modelValue", "placeholder"]))
}